/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 2dMe7XWUq916KsPnra5vYj
// Component: 4_ozDtECN_

import * as React from "react";

import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  Flex as Flex__,
  renderPlasmicSlot,
  StrictProps,
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";

import ActivityRow from "../../components/app-auth/ActivityRow"; // plasmic-import: jfBLn3a3U6/component
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: 2dMe7XWUq916KsPnra5vYj/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import "./plasmic_plasmic_kit_end_user_management.css"; // plasmic-import: 2dMe7XWUq916KsPnra5vYj/projectcss
import sty from "./PlasmicActivityTab.module.css"; // plasmic-import: 4_ozDtECN_/css

createPlasmicElementProxy;

export type PlasmicActivityTab__VariantMembers = {};
export type PlasmicActivityTab__VariantsArgs = {};
type VariantPropType = keyof PlasmicActivityTab__VariantsArgs;
export const PlasmicActivityTab__VariantProps = new Array<VariantPropType>();

export type PlasmicActivityTab__ArgsType = { children?: React.ReactNode };
type ArgPropType = keyof PlasmicActivityTab__ArgsType;
export const PlasmicActivityTab__ArgProps = new Array<ArgPropType>("children");

export type PlasmicActivityTab__OverridesType = {
  root?: Flex__<"div">;
};

export interface DefaultActivityTabProps {
  children?: React.ReactNode;
  className?: string;
}

const $$ = {};

function PlasmicActivityTab__RenderFunc(props: {
  variants: PlasmicActivityTab__VariantsArgs;
  args: PlasmicActivityTab__ArgsType;
  overrides: PlasmicActivityTab__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants,
  };

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const styleTokensClassNames = _useStyleTokens();

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "all",
        "root_reset_2dMe7XWUq916KsPnra5vYj",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.root
      )}
    >
      {renderPlasmicSlot({
        defaultContents: (
          <React.Fragment>
            <ActivityRow
              className={classNames("__wab_instance", sty.activityRow__bZRup)}
            />

            <ActivityRow
              className={classNames("__wab_instance", sty.activityRow__q0TY1)}
            />

            <ActivityRow
              className={classNames("__wab_instance", sty.activityRow__x4Tl8)}
              withoutBorder={true}
            />
          </React.Fragment>
        ),
        value: args.children,
      })}
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root"],
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicActivityTab__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicActivityTab__VariantsArgs;
    args?: PlasmicActivityTab__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & // Specify variants directly as props
  Omit<PlasmicActivityTab__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicActivityTab__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicActivityTab__ArgProps,
          internalVariantPropNames: PlasmicActivityTab__VariantProps,
        }),
      [props, nodeName]
    );
    return PlasmicActivityTab__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName,
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicActivityTab";
  } else {
    func.displayName = `PlasmicActivityTab.${nodeName}`;
  }
  return func;
}

export const PlasmicActivityTab = Object.assign(
  // Top-level PlasmicActivityTab renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements

    // Metadata about props expected for PlasmicActivityTab
    internalVariantProps: PlasmicActivityTab__VariantProps,
    internalArgProps: PlasmicActivityTab__ArgProps,
  }
);

export default PlasmicActivityTab;
/* prettier-ignore-end */
